import { useDarkModeGatingCriteria } from "features/dark-mode/hooks/useDarkModeGatingCriteria";

import { useDarkModeSettings } from "../hooks/useDarkModeSettings";
import DarkModeGatingMenuOption from "./DarkModeGatingMenuButton";
import DarkModeToggle from "./DarkModeToggleMenuButton";

type Props = {
  onClick?: () => void;
  bypassGating?: boolean;
};

export default function DarkModeMenuButton({
  onClick,
  bypassGating = false
}: Props) {
  const { darkModeEnabled, toggleDarkMode } = useDarkModeSettings();

  const { criteriaMet, isLoading } = useDarkModeGatingCriteria();

  return (criteriaMet && !isLoading) || bypassGating ? (
    <DarkModeToggle isEnabled={darkModeEnabled} toggle={toggleDarkMode} />
  ) : (
    <DarkModeGatingMenuOption onClick={onClick} />
  );
}
